;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.8";import * as Sentry from '@sentry/nextjs';

import { tagApolloError } from './utils/capture';

const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NEXT_PUBLIC_NODE_ENV,
    tracesSampleRate: 0.1,
    ignoreErrors: [
      // Thrown by the script the Facebook Android in-app browser injects
      // (navigation_performance_logger_android) when its native bridge is
      // torn down on beforeunload. Not our code and not user-facing.
      'Java object is gone',
    ],
    beforeSend: tagApolloError,
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
